import { Page } from '@/core/architecture'

import { PersonalInfoSettingsTemplate } from './template'
import { useViewModel } from './viewModel'

export const PersonalInfoSettings: Page = () => {
  const { state, actions } = useViewModel()

  return <PersonalInfoSettingsTemplate state={state} {...actions} />
}
